import React, { useState, useEffect } from 'react';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';

import './Inventory.scss';
import { Col, Modal } from 'react-bootstrap';
import { GET_BOXES_TO_EDIT, GET_LOAD_INFO } from '../../../graphql/client/queries';
import { useMutation, useQuery } from '@apollo/client/react';
import { useLazyQuery } from '@apollo/client/react';
import { CustomButton, Loading } from '../../_common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchableDropdown, { DropdownOption } from '../../_common/SearchableDropdown/SearchableDropdown';
import { VALIDATE_INVENTORY_BOX } from '../../../graphql/client/mutations';
import { GetBoxesToEdit, GetLoadInfo, ValidateInventoryBox } from '../../../types/schemaTypes';
import { useStoreContext } from '../../App/StoreProvider';
import {
    GetFullJobProfile_getJobProfile_jobDetails as JobProfileData,
} from '../../../types/schemaTypes';
import MultiSelectDropdownV2 from '../../_common/MultiSelectDropdown/MultiSelectDropdownV2';
import MultiSelectDropdownV3 from '../../_common/MultiSelectDropdown/MultiSelectDropdownV3';

interface EditBoxesModalProps {
    jobData: JobProfileData;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    mutationLoading: boolean;
    modalError: string;
    setModalError: React.Dispatch<React.SetStateAction<string>>;
    handleOnSave: (boxIds, loadId, jobSummaryId, weight, action, sandTicket, boxNumber) => void;
}

interface OptionType {
    label: string;
    value: string;
}

const EditBoxesModal = ({
    showModal,
    setShowModal,
    mutationLoading,
    modalError,
    setModalError,
    handleOnSave,
    jobData,
}: EditBoxesModalProps): React.ReactElement => {
    const [state] = useStoreContext();
    const { auth } = state;

    const searchIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'search' }} />;

    const [boxId, setBoxId] = useState('');
    const [boxNumber, setBoxNumber] = useState<string>('');
    const [sandTicket, setSandTicket] = useState<string>('');
    const [loadId, setLoadId] = useState<number>();
    const [action, setAction] = useState<'Delete' | 'Add'>('Delete');
    const [jobSummaryId, setJobSummaryId] = useState<number>();
    const [weight, setWeight] = useState<number>();

    const [isContinueMode, setIsContinueMode] = useState(false);
    const [fetchLoadDetails, setFetchLoadDetails] = useState(true);
    const initialSelectedBoxes: OptionType[] = [];
    const [selectedBoxes, setSelectedBoxes] = useState(initialSelectedBoxes);
    const [selectedBoxIds, setSelectedBoxIds] = useState('');

    const boxlist: DropdownOption[] = [];
    const boxesList: OptionType[] = [];
    const { loading: getBoxesLoading, error: getBoxesError, data: boxesData } = useQuery<GetBoxesToEdit>(GET_BOXES_TO_EDIT, {
        variables: {
            jobId: 0,
        },
        fetchPolicy: 'network-only',
    });
    if (boxesData && boxesData.getBoxesToEdit) {
        boxesData.getBoxesToEdit.forEach(box => {
            if (box) {
                boxlist.push({
                    id: box.boxId ?? 0,
                    name: box.boxDesc ?? '',
                });
                boxesList.push({
                    value: String(box.boxId ?? 0),
                    label: box.boxDesc ?? '',
                });
            }
        });
    }


    const [validateInventoryBox, { loading: validateInventoryBoxLoading }] = useMutation<ValidateInventoryBox>(VALIDATE_INVENTORY_BOX, {
        onCompleted: (data) => {
            if (data && data.validateInventoryBox?.errors?.length !== 0) {
                let errorMessage = "";
                data.validateInventoryBox?.errors?.map(error => {
                    errorMessage = errorMessage + ' ' + error;
                })
                setIsContinueMode(true);
                setModalError(errorMessage);
            }
            else if (data && data.validateInventoryBox?.errors?.length === 0) {
                handleOnSave(boxId.toString(), loadId, jobSummaryId, weight, action, sandTicket, boxNumber);
            }
        },
        onError: (error) => {
            setModalError(error.message);
            setIsContinueMode(false);
        }
    });

    const [getLoadInfo, { loading: getLoadInfoLoading, error: getLoadInfoError, data: loadInfo }] = useLazyQuery<GetLoadInfo>(GET_LOAD_INFO, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (getLoadInfoLoading || !loadInfo?.getLoadInfo || !fetchLoadDetails) return;
        setFetchLoadDetails(false);
        setLoadId(loadInfo.getLoadInfo.loadId ?? 0);
        setJobSummaryId(loadInfo.getLoadInfo.jobSummaryId ?? 0);
        setWeight(loadInfo.getLoadInfo.weight ?? 0);
        validateInventoryBox({
            variables: {
                input: {
                    boxId: parseInt(boxId, 10),
                    loadId: loadInfo.getLoadInfo.loadId ?? 0,
                },
            },
        });
    }, [getLoadInfoLoading, loadInfo, fetchLoadDetails, boxId, validateInventoryBox]);

    useEffect(() => {
        if (!getLoadInfoError) return;
        const err = getLoadInfoError as { graphQLErrors?: Array<{ extensions?: { response?: { body?: { Message?: string } } } }> };
        const body = err.graphQLErrors?.[0]?.extensions?.response?.['body'];
        if (body?.Message) {
            setModalError(prev => (prev.length === 0 ? String(body.Message).replace('Internal Server Error:', '') : prev));
        }
    }, [getLoadInfoError]);

    // const onChangeBox = boxId => {
    //     setModalError('');
    //     setIsContinueMode(false);
    //     boxlist.map(box => {
    //         if (box.id == boxId) {
    //             setBoxNumber(box.name.toString());
    //         }
    //     });
    //     setBoxId((boxId));
    // };

    const handleOnChangeBox = (selectedBox: OptionType | OptionType[] | null): void => {
        setModalError('');
        setIsContinueMode(false);
        const selectedBoxValues: number[] = [];
        if (selectedBox && Array.isArray(selectedBox)) {
            setSelectedBoxes(selectedBox);
            for (let i = 0; i < selectedBox.length; i++) {
                selectedBoxValues.push(parseInt(selectedBox[i].value));
            }
            setSelectedBoxIds(selectedBoxValues.toString());
        } else if (selectedBox) {
            boxlist.map(box => {
                if (box.id == selectedBox.value) {
                    setBoxId(selectedBox.value);
                    setBoxNumber(box.name.toString());
                }
            });
            setSelectedBoxes([selectedBox]);
            setSelectedBoxIds(selectedBox.value.toString());
        }
    };

    const onChangeSandTicket = sandTicket => {
        setModalError('');
        setIsContinueMode(false);
        setSandTicket(sandTicket);
    };

    const onChangeLoadId = loadId => {
        setModalError('');
        setIsContinueMode(false);
        if (Number.isNaN(loadId) || !Number.isInteger(loadId) || loadId === 0) setLoadId(-1);
        else setLoadId(loadId);
    };

    const onClickClose = () => {
        setModalError('');
        setIsContinueMode(false);
        setShowModal(false);
    };

    const onClickContinue = async () => {
        setModalError('');
        if (action === 'Add' && auth.user.profile.role === "Field Admin") {
            setIsContinueMode(false);
            handleOnSave(boxId, loadId, jobSummaryId, weight, action, sandTicket, boxNumber);
        }
    };

    const onClickSave = async () => {
        setModalError('');
        if (action === 'Add') {
            setFetchLoadDetails(true);
            getLoadInfo({
                variables: {
                    input: {
                        sandTicket: sandTicket,
                        loadId: (loadId && loadId !== -1) ? loadId : 0,
                    },
                },
            });
        } else if (action === 'Delete') {
            handleOnSave(selectedBoxIds, -1, jobData.jobId, 0, action, '', 0);
        }
    };

    return (
        <Modal show={showModal} onHide={onClickClose} dialogClassName="Inventory-Setup-Container">
            <Modal.Header className="Inventory-Setup-Header">
                <Modal.Title className="Inventory-Setup-Header-Container">
                    <button className="material-icons Inventory-Setup-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="Inventory-Setup-Title">Edit Inventory</div>
                    <div className="Inventory-Setup-Error">{modalError}</div>
                </Modal.Title>
            </Modal.Header>

            {(mutationLoading || getLoadInfoLoading || validateInventoryBoxLoading) && (
                <div className="Inventory-Setup-Spinner">
                    <Loading />
                </div>
            )}

            <Modal.Body className="Inventory-Setup-Body">
                <Col md={8}>
                    <div className="Textfield-InputTitle input-group-text">Box*</div>
                    {getBoxesLoading && <Loading />}
                    {(jobData.isBellyDump || action === 'Add') ? (
                        <div className="EditBox-Dropdown">
                            <SearchableDropdown
                                autoCompleteEnabled={true}
                                dropdownOptions={boxlist}
                                id="box"
                                label=""
                                onSelect={(eventKey) => {
                                    const selectedOption = boxesList.find(option => option.value === eventKey) || null;
                                    handleOnChangeBox(selectedOption);
                                }}
                                endIcon={searchIcon}
                            />
                        </div>) :
                    (
                        <div className="EditBox-Dropdown-multiSelect">
                            <MultiSelectDropdownV3
                                dropdownOptions={boxesList}
                                label=""
                                onChange={(value: OptionType): void => {
                                    handleOnChangeBox(value);
                                }}
                                key={`my_unique_select_key__${JSON.stringify(selectedBoxes)}`}
                                value={selectedBoxes}
                            />
                        </div>
                    )}
                </Col>

                <Col className="EditBox-Radio-Label">
                    <div className="Textfield-InputTitle input-group-text">Action</div>
                </Col>
                <Col md={4} className="EditBox-Radio-Container">
                    <div className="EditBox-Radio">
                        <input
                            className="EditBox-Radio-Button"
                            type="radio"
                            name="action"
                            checked={action === 'Delete'}
                            onChange={event => setAction('Delete')}
                        />
                        Delete
                    </div>
                    <div className="EditBox-Radio">
                        <input
                            className="EditBox-Radio-Button"
                            type="radio"
                            name="action"
                            checked={action === 'Add'}
                            onChange={event => { setAction('Add'); setSelectedBoxes([]); }}
                            disabled={jobData.isBellyDump? jobData.isBellyDump:false}
                        />
                        Add
                    </div>
                </Col>

                {action === 'Add' && (
                    <div className="EditBox-Input-Container">
                        <Col>
                            <div className="Textfield-InputTitle input-group-text">Sand Ticket*</div>
                            <input
                                type="text"
                                className="EditBox-Input"
                                value={sandTicket}
                                onChange={element => onChangeSandTicket(element.target.value)}
                            />
                        </Col>

                        <Col>
                            <div className="Textfield-InputTitle input-group-text">Load ID</div>
                            <input
                                type="number"
                                className="EditBox-Input"
                                onChange={element => onChangeLoadId(parseInt(element.target.value))}
                            />
                        </Col>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className="Inventory-Setup-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                {isContinueMode ? (
                    <CustomButton
                        title="Continue"
                        onClick={onClickContinue}
                        isDisabled={!boxId || (action === 'Add' && sandTicket.length === 0) || (auth.user.profile.role !== "Field Admin")}
                    />
                ) : (
                    <CustomButton
                        title="Save"
                        onClick={onClickSave}
                        isDisabled={(!selectedBoxIds) || (action === 'Add' && sandTicket.length === 0)}
                    />
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default EditBoxesModal;
